import { render } from "./CheckboxInput.vue?vue&type=template&id=397100ac"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"
script.render = render

export default script